import { createMRTColumnHelper, MRT_ColumnDef } from "material-react-table";
import { Work } from "../../types/work";
import {
  EntityWithMetadataTableSuffixColumns,
  createEntityFilterSpec,
  publishedIdColumn,
  withFieldProofreadingIndicator,
} from "./EntityUtils";
import type { FilterSpec } from "../../hooks/useServerFilters";
import EntityReferenceComponent from "../../components/entitiesReferences/EntityReferenceComponent";
import {
  UserEnumGroupView,
} from "../../components/forms/common/subForms/UserEnumGroupField";
const columnHelper = createMRTColumnHelper<Work>();

const maybeFieldProofreading = (
  metadataFieldName: string,
  render: (props: any) => React.ReactNode,
  withProofreading: boolean
) => withFieldProofreadingIndicator(metadataFieldName, render, withProofreading);

// No "Translated To" column: WorkFilters makes system_language_type mandatory
// and useWorkLogic resolves columns from it, so every work table is scoped to a
// single language and the value would repeat on every row.

const translationOfColumn = columnHelper.accessor("translation_of_indic_work", {
  header: "Translation of",
  enableColumnFilter: false,
  Cell: ({ cell }) =>
    cell.getValue() ? (
      <EntityReferenceComponent entity={cell.getValue()} />
    ) : (
      "-"
    ),
});

//const versionsColumn = columnHelper.accessor("versions", {
//  header: "Versions",
//  Cell: ({ cell }) => {
//    const items = cell.getValue<any[]>();
//    if (!items?.length) return "-";
//    return <div>{items.map(v => <EntityReferenceComponent key={v._key} entity={v} />)}</div>;
//  },
//});
// Related to version column in works table - commented out due to slow query issues this features triggered

const createBaseWorkColumnsNoChinese = (
  withProofreading: boolean
): MRT_ColumnDef<Work, any>[] => [
  columnHelper.accessor("availability", {
    header: "Availability",
    Cell: maybeFieldProofreading(
      "availability",
      ({ cell }) => cell.getValue() || "-",
      withProofreading
    ),
  }),
  columnHelper.accessor("keywords", {
    header: "Keywords",
    Cell: maybeFieldProofreading(
      "keywords",
      ({ cell }) => <UserEnumGroupView values={cell.getValue() as string[]} />,
      withProofreading
    ),
  }),
  columnHelper.accessor("compositional_form", {
    header: "Compositional Form",
    Cell: maybeFieldProofreading("compositional_form", ({ cell }) => {
      const value = cell.getValue() as string | undefined;
      return value || "-";
    }, withProofreading),
  }),
];

export const WorkColumns = [
  publishedIdColumn,
  ...createBaseWorkColumnsNoChinese(false),
  ...EntityWithMetadataTableSuffixColumns,
];

export const indicWorkColumns = [
  publishedIdColumn,
  //versionsColumn,
  // Related to version column in works table - commented out due to slow query issues this features triggered
  ...createBaseWorkColumnsNoChinese(false),
  ...EntityWithMetadataTableSuffixColumns,
];

export const tibetanWorkColumns = [
  publishedIdColumn,
  translationOfColumn,
  //versionsColumn,
  // Related to version column in works table - commented out due to slow query issues this features triggered
  ...createBaseWorkColumnsNoChinese(false),
  ...EntityWithMetadataTableSuffixColumns,
];

export const chineseWorkColumns = [
  publishedIdColumn,
  translationOfColumn,
  ...EntityWithMetadataTableSuffixColumns,
];

export const workTableColumns = [
  publishedIdColumn,
  ...createBaseWorkColumnsNoChinese(true),
  ...EntityWithMetadataTableSuffixColumns,
];

export const indicWorkTableColumns = [
  publishedIdColumn,
  ...createBaseWorkColumnsNoChinese(true),
  ...EntityWithMetadataTableSuffixColumns,
];

export const tibetanWorkTableColumns = [
  publishedIdColumn,
  translationOfColumn,
  ...createBaseWorkColumnsNoChinese(true),
  ...EntityWithMetadataTableSuffixColumns,
];

export const chineseWorkTableColumns = chineseWorkColumns;

// system_language_type is a structural discriminator; kept strict on the
// backend and not user-filterable via free text.
export const workFilterSpec: FilterSpec = createEntityFilterSpec({
  availability: { kind: "string" },
  keywords: { kind: "string" },
  compositional_form: { kind: "string" },
});
